import { Link } from 'react-router-dom';
import { useTheme, smoothScrollTo } from '../hooks';
import { Icon } from './Icon';

export function Nav() {
  const [theme, toggle] = useTheme();
  return (
    <nav className="lp-nav">
      <div className="mx-auto w-full max-w-[1180px] px-7 lp-nav-inner">
        <img src="/logo.svg" alt="CallXcel" className="lp-nav-logo" />
        <div className="lp-nav-links">
          <button className="lp-nav-link" onClick={() => smoothScrollTo('problem')}>Why CallXcel</button>
          <button className="lp-nav-link" onClick={() => smoothScrollTo('use-cases')}>Use cases</button>
          <button className="lp-nav-link" onClick={() => smoothScrollTo('how')}>How it works</button>
          <button className="lp-nav-link" onClick={() => smoothScrollTo('proof')}>Results</button>
          <button className="lp-nav-link" onClick={() => smoothScrollTo('faq')}>FAQ</button>
        </div>
        <div className="lp-nav-cta">
          <button
            className="theme-toggle"
            onClick={toggle}
            aria-label={theme === 'dark' ? 'Switch to light' : 'Switch to dark'}
          >
            <Icon name={theme === 'dark' ? 'sun' : 'moon'} size={17} />
          </button>
          <Link className="lp-btn lp-btn-ghost lp-btn-sm" to="/app">Sign in</Link>
          <button className="lp-btn lp-btn-orange lp-btn-sm" onClick={() => smoothScrollTo('top')}>
            Try 50 calls free
          </button>
        </div>
      </div>
    </nav>
  );
}
